(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .factory('twitterMentionService', twitterMentionService);

  /* ngInject */
  function twitterMentionService($resource, config) {
    let url = `${config.socialMediaComplianceApiEndpoint}/api/twitter_mentions/:id`;
    let paramDefaults = {id: '@id'};
    let headers = authToken => ({'Authorization': 'Token token=' + authToken});
    let actions = authToken => ({
      'query': { 
        method: 'GET', 
        headers: headers(authToken),
        transformResponse: function(data, headers) {
          let response = {};
          response.data = angular.fromJson(data);
          response.headers = headers();
          return response;
        }
      }
    });

    return authToken => $resource(url, paramDefaults, actions(authToken));
  }
})();
